// middleware/auth.js
export default defineNuxtRouteMiddleware(async (to) => {
  const { $pb } = useNuxtApp();
  const publicPages = ['/login', '/register', '/forgot-password', '/reset-password', '/email-verification'];
  const authRequired = !publicPages.includes(to.path);

  // Skip home page
  if (to.path === '/') return;

  // Server-side check
  if (import.meta.server) {
    try {
      if (authRequired && !$pb.authStore.isValid) {
        return navigateTo('/login');
      }
      if (!authRequired && $pb.authStore.isValid) {
        return navigateTo('/app');
      }
    } catch (error) {
      if (authRequired) {
        return navigateTo('/login');
      }
    }
  }

  // Client-side check
  if (import.meta.client) {
    const isAuthenticated = $pb.authStore.isValid;
    
    if (authRequired && !isAuthenticated) {
      return navigateTo('/login');
    }
    if (!authRequired && isAuthenticated) {
      return navigateTo('/app');
    }
  }
});